// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__miCgN","range":"MonthRangeSwitch_range__40MLF","disabled":"MonthRangeSwitch_disabled__33ZqG"};